var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.10264 1.48338C7.46948 0.74021 8.52922 0.74021 8.89606 1.48338L10.3419 4.41251C10.4874 4.70735 10.7686 4.91181 11.094 4.95937L14.3289 5.4322C15.1488 5.55204 15.4756 6.55988 14.882 7.13804L12.5428 9.41642C12.3069 9.64616 12.1993 9.97729 12.2549 10.3018L12.8068 13.5194C12.9469 14.3363 12.0893 14.9593 11.3557 14.5735L8.4648 13.0532C8.17342 12.9 7.82528 12.9 7.5339 13.0532L4.64298 14.5735C3.90935 14.9593 3.0518 14.3363 3.19192 13.5194L3.74377 10.3018C3.79943 9.97729 3.69177 9.64616 3.45589 9.41642L1.1167 7.13804C0.523103 6.55988 0.849885 5.55204 1.6698 5.4322L4.90472 4.95937C5.23007 4.91181 5.51126 4.70735 5.6568 4.41251L7.10264 1.48338Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.37ac4786cfce9f702391d5060f075c81.svg";
export { ForwardRef as ReactComponent };